import { useState, useEffect } from 'react'

// Global state outside hook to keep all instances synchronized
let globalTimeLeft = 643 // 10 minutes 43 seconds
let isRunning = false
const listeners: Set<React.Dispatch<React.SetStateAction<number>>> = new Set()

const startGlobalTimer = () => {
  if (isRunning) return
  isRunning = true

  setInterval(() => {
    globalTimeLeft = Math.max(0, globalTimeLeft - 1)
    listeners.forEach((setLocalTime) => setLocalTime(globalTimeLeft))
  }, 1000)
}

export const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(globalTimeLeft)

  useEffect(() => {
    listeners.add(setTimeLeft)
    startGlobalTimer()

    return () => {
      listeners.delete(setTimeLeft)
    }
  }, [])

  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60)
    const s = seconds % 60
    return {
      minutes: m.toString().padStart(2, '0'),
      seconds: s.toString().padStart(2, '0'),
    }
  }

  return {
    timeLeft,
    formattedTime: formatTime(timeLeft),
    isExpired: timeLeft === 0,
  }
}
